// Per-salon off-platform payment method catalog.
//
// Backend table: salon_payment_methods. Each salon has 4 seeded defaults
// (Check / Venmo / CashApp / Zelle) with `is_default=true` that cannot be
// deleted or renamed. Salons add their own custom rows (≤100 chars,
// case-insensitive-unique per salon) and pick up to 8 via `is_selected`
// to expose at checkout.
//
// Cash, Card-on-File, "Default Checkout (No Payments Solution)", and live
// Card payments are hardcoded system tiles on the checkout grid and are
// NOT stored in this catalog.

export interface SalonPaymentMethod {
  id: string;
  name: string;
  is_default: boolean;
  is_selected: boolean;
  sort_order: number;
}

export interface AddSalonPaymentMethodResponse {
  created: SalonPaymentMethod;
  payment_methods: SalonPaymentMethod[];
}

export interface SalonPaymentMethodsListResponse {
  payment_methods: SalonPaymentMethod[];
}

export const MAX_SELECTED_PAYMENT_METHODS = 8;
export const PAYMENT_METHOD_NAME_MAX_LENGTH = 100;
